export default "<button (click)=\"dataSource.saveAction()\" class=\"mt1\">Proceed</button>\n";